// src/components/Nav.js
import React, { useState, useEffect, useRef } from "react";
import "../fonts/bootstrap-icons.woff";
import "../fonts/bootstrap-icons.woff2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/main.css";
import "../css/bootstrap-icons.css";
// Import the Bootstrap bundle so that all plugins are loaded.
import "bootstrap/dist/js/bootstrap.bundle";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { auth } from "../firebase";
import { Collapse } from "bootstrap";

const Demo = () => (
  <div>
    <Helmet>
      {/* Remove duplicate/conflicting scripts.
          For Bootstrap 5, you don't need jQuery.
          <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
          <script src="/js/jquery.sticky.js" type="text/javascript"></script>
          <script src="/js/click-scroll.js" type="text/javascript"></script>
          <script src="/js/custom-nav.js" type="text/javascript"></script>
      */}
    </Helmet>
  </div>
);

function Navbar() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  
  // Track whether the navbar is collapsed.
  const [isCollapsed, setIsCollapsed] = useState(true);

  // Refs for the collapse element and its instance.
  const collapseRef = useRef(null);
  const collapseInstanceRef = useRef(null);

  // Initialize the collapse instance once after mount.
  useEffect(() => {
    if (collapseRef.current && !collapseInstanceRef.current) {
      collapseInstanceRef.current = new Collapse(collapseRef.current, {
        toggle: false, // Don't toggle automatically.
      });
    }
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Smooth scroll on hash change on the homepage.
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // Manually toggle the collapse.
  const toggleNavbar = () => {
    if (collapseInstanceRef.current) {
      collapseInstanceRef.current.toggle();
      // Toggle our state so the icon updates.
      setIsCollapsed((prev) => !prev);
    }
  };

  // Hide the navbar (if open) and update the state.
  const hideNavbar = () => {
    if (collapseInstanceRef.current) {
      collapseInstanceRef.current.hide();
      setIsCollapsed(true);
    }
  };

  // For links that scroll to sections.
  const handleScrollLinkClick = (e, section) => {
    if (location.pathname !== "/") {
      e.preventDefault();
      window.location.href = `/#${section}`;
    } else {
      hideNavbar();
    }
  };

  // For regular (non-scroll) links.
  const handleNavLinkClick = () => {
    hideNavbar();
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      hideNavbar();
    } catch (error) {
      console.error("Error during sign-out:", error);
    }
  };

  return (
<nav className="navbar navbar-expand-lg navbardesktop">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={handleNavLinkClick}>
          <img src="../back (1).png" alt="NutriPlan Logo" />
          <span Classname="navbar-brand">NutriPlan</span>
        </Link>

        <div className="d-lg-none ms-auto me-4">
          {!user && (
            <Link
              to="/login"
              className="navbar-icon bi-person smoothscroll"
              onClick={handleNavLinkClick}
            ></Link>
          )}
        </div>

        {/* Remove data attributes and use our manual toggle.
            The class "collapsed" and aria-expanded are set based on our state */}
        <button
          className={`navbar-toggler ${isCollapsed ? "collapsed" : ""}`}
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={!isCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Attach the ref to the collapse element */}
        <div ref={collapseRef} className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-lg-5 me-lg-auto">
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="section_1"
                smooth
                duration={500}
                offset={-70}
                onClick={(e) => handleScrollLinkClick(e, "section_1")}
              >
                Home
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="section_2"
                smooth
                duration={500}
                offset={-70}
                onClick={(e) => handleScrollLinkClick(e, "section_2")}
              >
                Trackers
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="section_3"
                smooth
                duration={500}
                offset={-70}
                onClick={(e) => handleScrollLinkClick(e, "section_3")}
              >
                How it works
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="section_4"
                smooth
                duration={500}
                offset={-70}
                onClick={(e) => handleScrollLinkClick(e, "section_4")}
              >
                FAQs
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="section_5"
                smooth
                duration={500}
                offset={-70}
                onClick={(e) => handleScrollLinkClick(e, "section_5")}
              >
                Contact
              </ScrollLink>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/plans" onClick={handleNavLinkClick}>
                Plans and Pricing
              </Link>
            </li>
          </ul>

          <ul className="navbar-nav ms-lg-auto">
            {user ? (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle d-flex align-items-center"
                  href="#!"
                  id="profileDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={
                      user.photoURL ||
                      "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                    }
                    alt="Profile"
                    className="rounded-circle me-2"
                    width="30"
                    height="30"
                  />
                  <span>{user.displayName}</span>
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="profileDropdown"
                >
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/dashboard"
                      onClick={handleNavLinkClick}
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            ) : (
              <li className="nav-item">
                <Link className="nav-link" to="/login" onClick={handleNavLinkClick}>
                  Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default function Nav() {
  return (
    <>
      <Navbar />
      <Demo />
    </>
  );
}
